import { render, staticRenderFns } from "./TranslateLanguages.vue?vue&type=template&id=fd38e7aa"
import script from "./TranslateLanguages.vue?vue&type=script&lang=js"
export * from "./TranslateLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports